import {CURRENT_DOMAIN_NAME} from "../actions/actionTypes";


const domainName = (state = {domain: ''}, action) => {
    switch (action.type) {
        case CURRENT_DOMAIN_NAME:
            // console.log("This is domain", action.name);
            return {...state, domain: action.name};
        default:
            return state;
    }
};

export default domainName;



// WEBPACK FOOTER //
// ./src/reducers/domainReducer.js